// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__cTjr2","intro":"Sidebar_intro__Q3Qea","logoWrapper":"Sidebar_logoWrapper__q8TYJ"};